import Vue from "vue";

export default {
  deletarTelefone(telefone) {
    return Vue.axios.delete("telefone/" + telefone.oid);
  },
};